import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "ion-padding" }
const _hoisted_2 = {
  key: 0,
  class: "ion-text-center"
}
const _hoisted_3 = ["src", "alt"]
const _hoisted_4 = { key: 0 }
const _hoisted_5 = {
  key: 1,
  class: "sub-badge sub-badge-deleted"
}
const _hoisted_6 = {
  key: 2,
  class: "sub-badge sub-badge-draft"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_back_button = _resolveComponent("ion-back-button")!
  const _component_ion_buttons = _resolveComponent("ion-buttons")!
  const _component_ion_title = _resolveComponent("ion-title")!
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_list = _resolveComponent("ion-list")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_header, {
        class: _normalizeClass(["ion-no-border events-page-header", { 'page-header--scrolled': _ctx.headerScrolled }])
      }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_toolbar, null, {
            default: _withCtx(() => [
              _createVNode(_component_ion_buttons, { slot: "start" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_back_button, {
                    text: "",
                    "default-href": "/showcase"
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_ion_title, null, {
                default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                  _createTextVNode("Управление подписками", -1)
                ]))]),
                _: 1
              }),
              _createVNode(_component_ion_buttons, { slot: "end" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_button, {
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push('/admin-subscriptions/new')))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_icon, { icon: _ctx.addOutline }, null, 8, ["icon"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["class"]),
      _createVNode(_component_ion_content, {
        class: "main-background events-content",
        fullscreen: true,
        onIonScroll: _ctx.onContentScroll
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            (_ctx.loading)
              ? (_openBlock(), _createElementBlock("p", _hoisted_2, "Загрузка..."))
              : (_openBlock(), _createBlock(_component_ion_list, {
                  key: 1,
                  lines: "full"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.subscriptions, (sub) => {
                      return (_openBlock(), _createBlock(_component_ion_item, {
                        key: sub.id,
                        button: "",
                        onClick: ($event: any) => (_ctx.$router.push(`/admin-subscriptions/${sub.id}/edit`))
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("img", {
                            src: sub.logoPath ? _ctx.subscriptionsService.logoUrl(sub.logoPath) : _ctx.defaultLogo,
                            slot: "start",
                            class: "sub-logo",
                            alt: sub.title
                          }, null, 8, _hoisted_3),
                          _createVNode(_component_ion_label, null, {
                            default: _withCtx(() => [
                              _createElementVNode("h2", null, _toDisplayString(sub.title), 1),
                              (sub.durationDays)
                                ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(sub.durationDays) + " " + _toDisplayString(_ctx.durationLabel(sub.durationDays)), 1))
                                : _createCommentVNode("", true),
                              (sub.deletedAt)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_5, "Удалено"))
                                : (sub.published === false)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_6, "Черновик"))
                                  : _createCommentVNode("", true)
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_component_ion_button, {
                            fill: "clear",
                            slot: "end",
                            onClick: _withModifiers(($event: any) => (_ctx.$router.push(`/admin-subscriptions/${sub.id}/edit`)), ["stop"])
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_icon, {
                                icon: _ctx.createOutline,
                                class: "admin-edit-icon"
                              }, null, 8, ["icon"])
                            ]),
                            _: 1
                          }, 8, ["onClick"])
                        ]),
                        _: 2
                      }, 1032, ["onClick"]))
                    }), 128))
                  ]),
                  _: 1
                }))
          ])
        ]),
        _: 1
      }, 8, ["onIonScroll"])
    ]),
    _: 1
  }))
}